import React from "react";
import { Table } from "semantic-ui-react";
import styles from "../../../../../../styles";
import injectSheet from "react-jss";
const NoDay = ({ classes }) => <Table.Cell className={classes.noDay} />;
export default injectSheet(styles)(NoDay);
